(function () {
  function getSlider(el) {
    return el.closest('[data-card-slider]');
  }

  function updateDots(slider) {
    var track = slider.querySelector('[data-card-slider-track]');
    var dots = slider.querySelectorAll('.card__slider-dot');
    if (!dots.length || !track.clientWidth) return;
    var index = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function scrollToIndex(slider, index) {
    var track = slider.querySelector('[data-card-slider-track]');
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }

  // --- Flèches / dots (inchangé) ---
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-card-slider-prev]');
    var next = e.target.closest('[data-card-slider-next]');
    var dot = e.target.closest('.card__slider-dot');

    if (prev || next) {
      e.preventDefault();
      e.stopPropagation();
      var slider = getSlider(prev || next);
      var track = slider.querySelector('[data-card-slider-track]');
      var currentIndex = Math.round(track.scrollLeft / track.clientWidth);
      var maxIndex = slider.querySelectorAll('.card__slide').length - 1;
      var targetIndex = prev ? currentIndex - 1 : currentIndex + 1;
      targetIndex = Math.max(0, Math.min(maxIndex, targetIndex));
      scrollToIndex(slider, targetIndex);
    }

    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      var slider2 = getSlider(dot);
      var dots = Array.prototype.slice.call(slider2.querySelectorAll('.card__slider-dot'));
      scrollToIndex(slider2, dots.indexOf(dot));
    }
  });

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.matches || !track.matches('[data-card-slider-track]')) return;
    var slider = getSlider(track);
    window.requestAnimationFrame(function () { updateDots(slider); });
  }, true);

  // --- Tap = navigation produit / Drag = swipe (nouveau) ---
  var pointerState = new WeakMap();
  var DRAG_THRESHOLD = 10; // px

  function onPointerDown(slider, x, y) {
    pointerState.set(slider, { startX: x, startY: y, moved: false });
  }

  function onPointerMove(slider, x, y) {
    var state = pointerState.get(slider);
    if (!state) return;
    if (Math.abs(x - state.startX) > DRAG_THRESHOLD || Math.abs(y - state.startY) > DRAG_THRESHOLD) {
      state.moved = true;
    }
  }

  function onPointerUp(slider, target) {
    var state = pointerState.get(slider);
    if (!state) return;
    var isControl = target.closest('[data-card-slider-prev]') ||
                     target.closest('[data-card-slider-next]') ||
                     target.closest('.card__slider-dot');
    if (!state.moved && !isControl) {
      var url = slider.getAttribute('data-card-slider-url');
      if (url) window.location.href = url;
    }
    pointerState.delete(slider);
  }

  document.addEventListener('touchstart', function (e) {
    var slider = e.target.closest('[data-card-slider]');
    if (!slider) return;
    var t = e.touches[0];
    onPointerDown(slider, t.clientX, t.clientY);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var slider = e.target.closest('[data-card-slider]');
    if (!slider) return;
    var t = e.touches[0];
    onPointerMove(slider, t.clientX, t.clientY);
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var slider = e.target.closest('[data-card-slider]');
    if (!slider) return;
    onPointerUp(slider, e.target);
  });

  document.addEventListener('mousedown', function (e) {
    var slider = e.target.closest('[data-card-slider]');
    if (!slider) return;
    onPointerDown(slider, e.clientX, e.clientY);
  });

  document.addEventListener('mousemove', function (e) {
    if (e.buttons !== 1) return;
    var slider = e.target.closest('[data-card-slider]');
    if (!slider) return;
    onPointerMove(slider, e.clientX, e.clientY);
  });

  document.addEventListener('mouseup', function (e) {
    var slider = e.target.closest('[data-card-slider]');
    if (!slider) return;
    onPointerUp(slider, e.target);
  });
})();